import * as React from "react"
import Loader from "../components/loader"
import Logo from "../components/logo" 
import gsap from 'gsap'

class BottomMenu extends React.Component {
  componentDidMount() {
    this.initialiseMenu();
  }
  initialiseMenu() {
    if(document.querySelector('.sections-with--navigation')) {
      document.querySelector('.page--navigation').classList.add('display');
    }
    document.querySelector('.loader-icon').classList.remove('is-rotating');
    var tl = gsap.timeline({repeat: 0, paused:true});
    tl.to(document.querySelector('.loader-icon'), 1.5, {rotation:"+=360", ease:"none", repeat:2});
    tl.to(document.querySelector('.loader-icon'), 1.5, {rotation:"+=180", ease:"power1.out", onComplete:function() { document.querySelector('.page--navigation').classList.add('is-showing');}});
    tl.play();   
  }
  render() {
    return (
      <div className="bottom-menu--fixed flex">
        <div className="page--navigation strong" data-slide="1"> 
          <span className="slide"><span className="inner"></span></span>
          <span className="total">/<span className="ml10">0<span className="count"></span></span></span>

        </div>
        <div className="bottom-nav--internal align-self--bottom w-100 m-auto">
          <div className="flex p30">
            <div className="loader mra">
              <div className="icon-will--rotate">
                <Loader />
              </div>
            </div>
            <div className="logo mla m-hide">
              <div className="main-logo--wrapper">
                <a href="/" className="internal--link">
                  <Logo />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
} 

export default BottomMenu

